import * as yup from 'yup';
import { object } from 'yup';
import { validateVatNumber } from 'utils/validator';
import { backupUserSchema, userStr } from '../../utils';

export const formTitle = 'intermediary.organisationBillingInfo.formTitle';

// this is used to toggle the different schema entries that are and
// are not required according whether the billing is webInvoice or not
const isRequiredByEInvoice = bool =>
  yup.string().when('webInvoice', {
    is: bool,
    then: yup
      .string()
      .required('general.form.validation.mandatory')
      .label(formTitle),
    otherwise: yup
      .string()
      .notRequired()
      .nullable()
  });

const userSchema = object({
  firstName: userStr(true, 'firstNameIsRequired', formTitle),
  lastName: userStr(true, 'lastNameIsRequired', formTitle),
  email: userStr(true, 'emailIsRequired', formTitle, true),
  phoneNumber: userStr(false, 'phoneNumberIsRequired', formTitle)
});

export const schema = () =>
  yup.object({
    organisationBillingInfoDisabled: yup
      .boolean()
      .required()
      .default(false),
    organisationBillingInfo: yup
      .object({
        organizationName: yup
          .string()
          .required('general.form.validation.mandatory')
          .default('')
          .label(formTitle),
        address: yup
          .string()
          .notRequired()
          .nullable()
          .label(formTitle),
        postalCode: yup
          .string()
          .notRequired()
          .nullable()
          .label(formTitle),
        postOffice: yup
          .string()
          .notRequired()
          .nullable()
          .label(formTitle),
        webInvoice: yup.boolean().default(true),
        referenceNumber: yup
          .string()
          .notRequired()
          .nullable(),
        webInvoiceHandlerIdentifier: isRequiredByEInvoice(true),
        webInvoiceAddress: isRequiredByEInvoice(true),
        vatNumber: yup
          .string()
          .notRequired()
          .nullable()
          .test(
            'validate-vat',
            'general.form.validation.invalid_vat',
            value => {
              if (!value) {
                return true;
              }
              return validateVatNumber(value);
            }
          )
          .label(formTitle),
        billingContactPerson: userSchema,
        billingContactBackupPerson: backupUserSchema(formTitle)
      })
      .when('organisationBillingInfoDisabled', {
        is: true,
        then: s => s.strip(),
        otherwise: s => s.required() // removes it from the validated output
      })
  });
